var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M10.9 18.9l4.7 4.8L33 6.6c1.1-1.1 3-1.1 4.1 0L39.4 9c1.1 1.1 1.1 3 0 4.1L15.6 36.7 3.2 24c-1.1-1.1-1.1-3 0-4.1l1-.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M10.9 18.9l4.7 4.8L33 6.6c1.1-1.1 3-1.1 4.1 0L39.4 9c1.1 1.1 1.1 3 0 4.1L15.6 36.7 3.2 24c-1.1-1.1-1.1-3 0-4.1l1-.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 7.5,
    cy: 15.6,
    r: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.7fec31d7ab498ac071288a5f9f88a8e8.svg";
export { ForwardRef as ReactComponent };